import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { CustomerInfoSection } from "./CustomerInfoSection";
import { InfoSection } from "./InfoSection";
import { useEffect, useState } from "react";
import { env } from "./env";
import { Alert } from "@material-tailwind/react";
import { DotLoader } from "react-spinners";

const url = new URL(window.location.href);
export const tripId = url.pathname.split("/")[1];

const stripePromise = loadStripe(env.stripeKey);

function App() {
  const [clientSecret, setClientSecret] = useState(null);
  const [ticketsAvailable, setTicketsAvailable] = useState(false);
  const [spotsLeft, setSpotsLeft] = useState();
  const [availabilityLoading, setAvailabilityLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [trip, setTrip] = useState(null);
  const [linkedTrips, setLinkedTrips] = useState(null);

  const getTrip = async (id, isPackageSelect = false) => {
    setLoading(!isPackageSelect);
    setFormLoading(true);
    setAvailabilityLoading(true);
    if (id) {
      let data;
      try {
        const response = await fetch(`${env.baseUrl}/trips/public/${id}`, {
          method: "GET",
          // Add any headers or other configuration if required
        });

        data = await response.json();

        const availability = await fetch(
          `${env.baseUrl}/payments/available/${data.id}`,
          {
            method: "POST",
            // Add any headers or other configuration if required
          }
        );

        const availabilityData = await availability.json();

        if (availabilityData.available) {
          if (data) {
            setTrip(data);
            // if coming from a package select tool dont set the linked trips again
            if (!isPackageSelect) {
              setLinkedTrips([data, ...data.linkedTrips]);
            }
          }
          setTicketsAvailable(true);
        } else {
          if (data && isPackageSelect) {
            return false;
          } else {
            setTrip(data);
            // if coming from a package select tool dont set the linked trips again
            if (!isPackageSelect) {
              setLinkedTrips([data, ...data.linkedTrips]);
            }
          }
          setTicketsAvailable(false);
        }
        setSpotsLeft(availabilityData.ticketsAvailable);
      } catch (error) {
        setTrip(false);
        setLoading(false);
        setFormLoading(true)
      }
      setLoading(false);
      setAvailabilityLoading(false);
      setFormLoading(true)
    } else {
      setTrip(false);
      setLoading(false);
      setFormLoading(true)
    }
    return true
  };

  useEffect(() => {
    getTrip(tripId);
  }, []);

  return loading ? (
    <div className="flex items-center justify-center h-screen">
      <DotLoader color={"#222222"} />
    </div>
  ) : !trip ? (
    <>
      <div className="text-center items-center w-auto min-w-full">
        <img
          src={"https://tts-user-uploads.s3.amazonaws.com/tts-logo-black.png"}
          alt="Logo"
          className="mx-auto h-64"
        />
      </div>
      <h1 className="text-center mt-12 text-3xl font-bold"> No trip found </h1>
      <Alert color="red" className="mt-8">
        This link is not to a valid trip.
      </Alert>
    </>
  ) : (
    <Elements stripe={stripePromise}>
      <div className="min-h-screen bg-white">
        <HeroSection trip={trip} />

        <section className="grid grid-cols-1 gap-4 md:grid-cols-2 bg-transparent md:-mt-24 relative">
          <InfoSection
            spotsLeft={spotsLeft}
            trip={trip}
            getTrip={getTrip}
            formLoading={formLoading}
            linkedTrips={linkedTrips}
          />
          {ticketsAvailable ? (
            <CustomerInfoSection
              setClientSecret={setClientSecret}
              formLoading={formLoading}
              trip={trip}
            />
          ) : !availabilityLoading ? (
            <section
              className="px-4 bg-white shadow-2xl"
              style={{ borderRadius: 20, margin: 20 }}
            >
              {/* <h1 className="text-center mt-12 text-3xl font-bold"> {trip.name} </h1> */}
              <Alert color="red" className="mt-4">
                Sorry we are sold out! To join the wait list for the trip,
                please follow this{" "}
                <a
                  className="text-blue-500 mt-8"
                  target="_blank"
                  href={trip.waitListFormUrl}
                >
                  link
                </a>
              </Alert>
            </section>
          ) : (
            <></>
          )}
        </section>
      </div>
    </Elements>
  );
}

function HeroSection({ trip }) {
  return (
    <section>
      <div className="h-2/3">
        <video
          playsInline
          autoPlay
          loop
          muted
          className="top-0 left-0 w-full h-full object-cover"
        >
          <source src={trip.portraitVideoSrc ? trip.portraitVideoSrc : trip.videoSrc} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
      <div className="text-center absolute z-20 top-0 items-center w-auto min-w-full">
        <img src={trip.logoSrc} alt="Logo" className="mx-auto h-64" />
      </div>
    </section>
  );
}

export default App;
